/* @flow */
import _ from 'lodash'

import {
  GET_SHOPS,
  GET_SHOPS_SUCCESS,
  GET_SHOPS_FAILURE,
  SET_VIEW_SHOP,
  SEARCH_SHOP,
} from '../../configs/constants'
import InitialState from './initialState'

const initialState = new InitialState()

export default function shopReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return initialState.merge(state)

  switch (action.type) {
    case GET_SHOPS:
      return state.set('isLoading', true)
    case GET_SHOPS_SUCCESS:
      return state.set('shops', action.shops)
                  .set('filtered', action.shops)
    case GET_SHOPS_FAILURE:
      return state.set('isLoading', false)
    case SET_VIEW_SHOP:
      return state.set('filtered', action.shops)
    case SEARCH_SHOP:
      return state.set('filtered', action.payload.keyword ?
        state.shops.filter( (shop) => _.values(action.payload.keyword).indexOf(shop.location) >= 0 ) :
        state.shops
      )
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/shop/index.js